import React from "react";
import appLogo from "@/assets/images/uninfo_logo.png";

interface AppLogoProps {
  size?: number;
  className?: string;
}

/**
 * Brand logo mark: the Uninfo HK yellow "U" shield + connected-campus network
 * logo rendered as a rounded image. The source PNG includes transparent
 * padding so the full artwork stays visible inside rounded clips at small
 * sizes; `object-contain` guarantees it is never stretched or cropped.
 */
const AppLogo: React.FC<AppLogoProps> = ({ size = 32, className = "rounded-lg" }) => (
  <img
    src={appLogo}
    alt="Uninfo HK"
    width={size}
    height={size}
    className={`object-contain ${className}`}
  />
);

export default AppLogo;